import StopHandlingCell from './container';

export default StopHandlingCell;
